import { createContext, useContext, useState } from "react";
const DIDBridgeContext = createContext();

export function DIDBridgeProvider({ children }) {
  const [pendingDIDs, setPendingDIDs] = useState(null);
  const [pendingFile, setPendingFile] = useState(null); // actual File object

  return (
    <DIDBridgeContext.Provider value={{ pendingDIDs, setPendingDIDs, pendingFile, setPendingFile }}>
      {children}
    </DIDBridgeContext.Provider>
  );
}